import { setLocaleCookie } from "@redotech/redo-i18n/locale-cookie";
import { parseLocale } from "@redotech/redo-i18n/resolve-shopper-locale";
import { useLayoutEffect } from "react";
import { takeStorefrontLocaleTag } from "./portal-path";

/**
 * Applies the Shopify Markets URL locale as if the shopper picked it, once per
 * page load. Call it above the `LocalizationProvider`: a layout effect runs
 * before the provider's effect resolves the locale from the cookie, so the
 * provider switches straight to it.
 */
export function useStorefrontLocale(localizationEnabled: boolean): void {
  useLayoutEffect(() => {
    if (!localizationEnabled) {
      return;
    }
    const locale = parseLocale(takeStorefrontLocaleTag());
    if (locale) {
      setLocaleCookie(locale);
    }
  }, [localizationEnabled]);
}
